import { render, staticRenderFns } from "./NotificationPane.vue?vue&type=template&id=6aeb83a5&scoped=true"
import script from "./NotificationPane.vue?vue&type=script&lang=ts"
export * from "./NotificationPane.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPane.vue?vue&type=style&index=0&id=6aeb83a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb83a5",
  null
  
)

export default component.exports